// extracted by css-extract-rspack-plugin
export default {"option":"CqyucmGnJZMks1Zf__option___","optionlabel":"UQN8Y_sz0oNFKocG__optionlabel___","signalIcon":"s6emtqXubeAN7Pnq__signalIcon___"};